import React from 'react';
import {
  SearchByNameResult,
  SearchByNameResultWithSearchCriteria,
} from 'pages/Search/models';
import { Typography, Row, Col, Divider, Tabs, Icon } from 'antd';
import SearchExport from 'pages/Search/SearchExport/SearchExport';
import SearchByNameResultTabs from './SearchByNameResultTabs';

const { Title } = Typography;
const { TabPane } = Tabs;

const ResultGrid: React.FC<{
  results: SearchByNameResultWithSearchCriteria;
}> = (props: { results: SearchByNameResultWithSearchCriteria }) => {
  const { results, searchCriteria } = props.results;

  return (
    <>
      <Row type="flex" justify="space-between" align="middle">
        <Col>
          <Title level={4}>Search Criteria: {searchCriteria}</Title>
        </Col>

        <SearchExport />
        <Divider dashed />
      </Row>

      <Tabs type="card">
        {results.length > 0 &&
          results.map((result: SearchByNameResult, index: number) => (
            <TabPane
              tab={
                <>
                  <Icon type="file" />
                  &nbsp;
                  {result.header}
                </>
              }
              key={`${index}`}
            >
              <SearchByNameResultTabs nameResult={result} />
            </TabPane>
          ))}
      </Tabs>
    </>
  );
};

export default React.memo(ResultGrid);
